module.exports = __webpack_public_path__ + "static/media/ReissueCard.eeec1842.svg";